const prefix = '@free-sauce';

export const SHOW_PANEL = `${prefix}/SHOW_PANEL`;
export const HIDE_PANEL = `${prefix}/HIDE_PANEL`;
export const CLEAN_FREE_SAUCES = `${prefix}/CLEAN_FREE_SAUCES`;
export const ADD_FREE_SAUCE = `${prefix}/ADD_FREE_SAUCE`;
